import { Store } from "./loader.store";
import * as Selectors from "./loader.selectors";
import { endAction, startAction } from "./loader.actions";
const publicActions = { startAction, endAction };
export const Loader = {
    Store,
    Effects: {},
    Selectors,
    Actions: publicActions,
};
